module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "copy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("Copyright © 2008 Fordham University Press")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotations in printed reviews, without the prior permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("The Animal That Therefore I Am")]), _vm._v(" was originally published in French as "), _c('em', [_vm._v("L’animal que donc je suis")]), _vm._v(" © 2006 Éditions Galilée.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Derrida, Jacques.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("[Animal que donc je suis. English]")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("The animal that therefore I am / Jacques Derrida ; edited by Marie-Louise Mallet ; translated by David Wills.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("     p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Includes bibliographical references (p. ).")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("ISBN-13: 978-0-8232-2790-7 (cloth : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("ISBN-13: 978-0-8232-2791-4 (pbk. : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("1. Animals (Philosophy) I. Mallet, Marie-Louise. II. Title."), _c('br'), _vm._v("B2430.D483A5513     2008"), _c('br'), _vm._v("194—dc22                                                                          2008007491")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("This work has been published with the assistance of the National Center for the Book—French Ministry of Culture.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Ouvrage publié avec le soutien du Centre national du livre—ministère français chargé de la culture.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322dcd54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 72
// module chunks = 0